import { create } from 'zustand';

interface SupportPanelStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useSupportPanelStore = create<SupportPanelStore>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
